export default {
  name: "dialogue",
  data () {
    return {
      isShowDialogue: false,
      isShowMask: false,
      isShowContent: false,
    }
  },

  props: {
    isShow: {
      type: Boolean,
      required: true,
    },
  },

  watch: {
    isShow: {
      immediate: true,
      handler (newValue) {
        if(newValue) {
          this.isShowDialogue = true;
          this.isShowMask = true;
          this.isShowContent = true;
        } else {
          this.isShowMask = false;
          this.isShowContent = false;
          window.setTimeout(() => {
            this.isShowDialogue = false;
          }, 300);
        }
      }
    }
  },

  methods: {
    close () {
      /* 关闭对话框 */
      this.isShowMask = false;
      this.isShowContent = false;
      window.setTimeout(() => {
        this.$emit("closeDialogue");
      }, 300);
    },
  },

}